
if (checkIfExists('#address-form')) {

  var country = $('#address-form').data('language');
  var csrf = $('#address-form input[name=_token]').val();

  // $('#city').on('keyup', function(){
    //   $('#city_id').val('');
    //   $('#zip').val('');
    //   $('#address').val('');
    //   $('#address_id').val('');
    //   ('#office_select').html('');
    //   $('#office_select').selectpicker('refresh');
    // });

    var city_id = $('#city_id').val();

    $("#city").autocomplete({
      source: "/"+country+"/profile/get-cities",
      focus: function() {
        // prevent value inserted on focus
        return false;
      },
      select: function (event, suggestion) {
        var name = suggestion.item.value;
        var value_input = suggestion.item.city;
        var city_id = suggestion.item.city_id;
        var zip = suggestion.item.zip;

        setTimeout(function(){
          $('#city').val(value_input);
          $('#city_id').val(city_id);
          $('#zip').val(zip);



          if (country == 'bg') {
            $("#address").autocomplete('option', 'source', "/"+country+'/profile/'+city_id+"/get-addresses")
            var data_office = {
              _token: csrf,
              city_id: city_id
            }
            $.ajax({
              url: "/"+country+"/profile/get-offices",
              dataType: 'json',
              type: 'post',
              data: data_office,
              success: function(data){
                $('#office_select').html('');
                $.each(data, function(key, value){
                  const option = `<option value="${value.id}|${value.type}">${value.label} - ${value.type}</option>`;
                  $('#office_select').append(option);
                })

                $('#office_select').selectpicker('refresh');
              }
            });


          }
        },150);
      }
    });

    $("#address").autocomplete({
      source: "/"+country+'/profile/'+$('#city_id').val()+"/get-addresses",
      focus: function() {
        // prevent value inserted on focus
        return false;
      },
      select: function (event, suggestion) {
        var name = suggestion.item.label;
        var address_id = suggestion.item.id;

        $('#address_id').val(address_id);
      }
    });

    $('#office_select').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
      var office = $('#office_select option:selected').text();
      $('#office').val(office);
    });
}
